import React from 'react';
import { TI_TRIGGERED_BY } from '../../triage/config';
import { Icon } from '../Icon/Icon';

export interface TriageTriggerBannerProps {
  triggeredBy?: string | undefined;
  sourceLabel?: string | undefined;
  surfacesIn?: string[] | undefined;
}

export function TriageTriggerBanner({ triggeredBy, sourceLabel, surfacesIn }: TriageTriggerBannerProps) {
  if (!triggeredBy) return null;
  const trig = TI_TRIGGERED_BY[triggeredBy];
  if (!trig) return null;

  const alsoRcm = surfacesIn?.includes('rcm');

  return (
    <div
      className="v6-fade-up v6-d-1"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flexWrap: 'wrap',
        padding: '10px 14px',
        marginBottom: 14,
        borderRadius: 12,
        background: trig.bg,
        border: `1px solid color-mix(in srgb, ${trig.color} 13%, transparent)`,
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          fontSize: 12,
          fontWeight: 600,
          color: trig.color,
          letterSpacing: '-0.005em',
        }}
      >
        <Icon kind={trig.icon} size={13} stroke={2} />
        Triggered by {trig.label}
      </span>
      {sourceLabel ? (
        <span style={{ fontSize: 12, color: 'var(--ink-2)', letterSpacing: '-0.005em' }}>
          · {sourceLabel}
        </span>
      ) : null}
      {alsoRcm ? (
        <span
          style={{
            marginLeft: 'auto',
            fontSize: 10.5,
            fontWeight: 600,
            color: 'color-mix(in srgb, var(--gold) 78%, #000)',
            background: 'color-mix(in srgb, var(--gold) 18%, var(--cream-1))',
            padding: '2px 9px',
            borderRadius: 5,
            letterSpacing: '0.02em',
          }}
        >
          Also shown in RCM panel
        </span>
      ) : null}
    </div>
  );
}
